import { render, staticRenderFns } from "./GestionPqr.vue?vue&type=template&id=32b5d287&scoped=true"
import script from "./GestionPqr.vue?vue&type=script&lang=js"
export * from "./GestionPqr.vue?vue&type=script&lang=js"
import style0 from "./GestionPqr.vue?vue&type=style&index=0&id=32b5d287&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b5d287",
  null
  
)

export default component.exports